import { createClient } from '@sanity/client';

export default createClient({
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID, // Find this at manage.sanity.io or in your sanity.json
  dataset: process.env.REACT_APP_DATASET_NAME, // this is from those question during 'sanity init'
  token: process.env.REACT_APP_SANITY_TOKEN,
  useCdn: false, // `false` if you want to ensure fresh data
  apiVersion: '2024-03-01'
})
